<template>
	<div class="flex">
		<input  style="border: none; width: 0px; padding: 0px; margin-top: 0px" id="calculatorButton">
		<button @click="showCalculator" 
			style="margin-left: 0px; padding: 12px; background: transparent;">
			<i style="color: #333;" class="calculator icon"></i>
		</button>
	</div>
</template>

<script>
export default {
	name: 'calculator',
	mounted () {
		let selector = '#calculatorButton'
		/* eslint-disable-next-line no-undef */
		$(selector).calculator({layout: $.calculator.scientificLayout});
	},
	methods: {
		showCalculator: function () {
			/* eslint-disable-next-line no-undef */
			$('#calculatorButton').focus()
		}
	}
}
</script>